/** Make remote PDF URLs loadable (trailing commas from backend remaps, Cloudinary HTTPS). */
export function normalizePdfUri(filePath) {
	let uri = String(filePath ?? "").trim();
	uri = uri.replace(/,+$/g, "").trim();
	if (!uri) {
		return "";
	}
	if (/^http:\/\/res\.cloudinary\.com\//i.test(uri)) {
		uri = `https://${uri.slice("http://".length)}`;
	}
	return uri;
}

export function isPdfLink(url) {
	const u = normalizePdfUri(url).split("?")[0].toLowerCase();
	return u.includes(".pdf");
}
